import { render, staticRenderFns } from "./SourceManage.vue?vue&type=template&id=c62adffa&scoped=true"
import script from "./SourceManage.vue?vue&type=script&lang=js"
export * from "./SourceManage.vue?vue&type=script&lang=js"
import style0 from "./SourceManage.vue?vue&type=style&index=0&id=c62adffa&prod&lang=scss&scoped=true"
import style1 from "./SourceManage.vue?vue&type=style&index=1&id=c62adffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62adffa",
  null
  
)

export default component.exports